import { EventEmitter, Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { BaseService } from "../shared/services/base.service";
import { Parceiro } from "../models/parceiro.model";

@Injectable({
  providedIn: "root",
})
export class ParametroParceiroService extends BaseService<Parceiro> {
  public valoresParametros: any = new EventEmitter();

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}`, injector);
  }

  getParametroParceiros(parceiroId): Observable<Parceiro[]> {
    return this.http.get<Parceiro[]>(
      `${environment.API_PRICE}/PriceParam/get-parametro-parceiro/${parceiroId}`
    );
  }

  salvaParamParceiros(novoParceiro): Observable<Parceiro[]> {
    return this.http.post<Parceiro[]>(
      `${environment.API_PRICE}/PriceParam/gravar-parametro-parceiro/`,
      novoParceiro
    );
  }

  emitSalvarEstimativa(parametros) {
    this.valoresParametros.emit(parametros);
  }
}
